import { createClient } from '@supabase/supabase-js'
import axios from 'axios'
import SHA1 from 'crypto-js/sha1'

class StorageServiceBase {
  // singletone
  constructor(__class__) {
    if (__class__.instance) {
      return __class__.instance
    }
    __class__.instance = this
    return this
  }

  configuration(...args) {}

  async setFileInStorage({ file, key }, privacy = 'private') {}

  async deleteFileInStorage(key) {}
}

class StorageServiceCloudinary extends StorageServiceBase {
  URL = `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}`
  constructor() {
    super(StorageServiceCloudinary)
    this.configuration()
  }

  configuration() {}
  createSignature({ public_id, timestamp }) {
    const stringToSign = `public_id=${public_id}&timestamp=${timestamp}${process.env.REACT_APP_CLOUDINARY_API_SECRET}`
    return SHA1(stringToSign).toString()
  }

  async crearImagenNegraFile(width = 100, height = 100, fileName = 'negro.png') {
    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    const ctx = canvas.getContext('2d')
    ctx.fillStyle = '#000'
    ctx.fillRect(0, 0, width, height)

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        const file = new File([blob], fileName, { type: 'image/png' })
        resolve(file)
      }, 'image/png')
    })
  }
  async setFileInStorage({ file, key }, privacy = 'private', ...args) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('public_id', key)
    // formData.append('api_key', 'test')
    formData.append('api_key', process.env.REACT_APP_CLOUDINARY_API_KEY)
    formData.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET)
    let { data, error } = await axios.post(`${this.URL}/upload/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    if (error) throw new Error(error)
    return {
      id: data.asset_id,
      public_id: data.public_id,
      public_url: data.secure_url,
    }
  }

  async deleteFileInStorage(key, ...args) {
    try {
      debugger
      const { data, error } = await axios.delete(
        `${process.env.REACT_APP_BACK_URL}/api/v1/storage/delete?public_id=${key}`,
      )
      return
    } catch (error) {
      console.error(error)
    }
  }
}
export default class StorageService extends StorageServiceBase {
  
  constructor() {
    super(StorageService)
    this.configuration()
  }

  configuration() {}

  async setFileInStorage({ file, key }, privacy = 'private', ...args) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('key', `${key}`.replace(/ /g, '_'))
    
    debugger
    try {
      const { data, error } = await axios.post(
        `${process.env.REACT_APP_BACK_URL}/api/v1/storage/`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      )
      debugger
      if (error) throw new Error(error)
      return data.data
      
    } catch (error) {
      console.error(error)
    }
  }

  async deleteFileInStorage(key, ...args) {
    try {
      debugger
      await axios.delete(
        `${process.env.REACT_APP_BACK_URL}/api/v1/storage/delete?public_id=${key}`,
      )
      return 'ok'
    } catch (error) {
      console.error(error)
    }
  }
}
